module.exports = __webpack_public_path__ + "static/media/gif2.d32ac84b.gif";